import React, {useState, useRef} from "react";
import {useAdmin} from "./AdminContext.js";
import {doc, setDoc, updateDoc, getDocs, serverTimestamp, collection, writeBatch} from "firebase/firestore";
import {CircularProgress, Typography} from '@mui/material';
import {useUser} from "../UserContext.js";
import {getFirestore} from "firebase/firestore";
import {getStorage, ref, listAll, deleteObject, uploadBytesResumable} from "firebase/storage";
import {useSnackbar} from "notistack";
import {Button} from "@mui/material";
import Papa from 'papaparse';
import "./../Styles.css";

const AddLocate = () => {
  const batchSize = 200;
  const {locates} = useAdmin();
  const {appUser} = useUser();
  const {enqueueSnackbar} = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState();
  const [newAmount, setNewAmount] = useState();
  const [actionMessage, setActionMessage] = useState("Loading...");

  // set new amount for selected symbol
  function trySetNewAmount(e) {
    if (!isNaN(e)) {
      setNewAmount(Number(e));
    } else {
      setNewAmount(Number(totalAmount + 1));
    }
  }
  //matched symbol entered in the input field
  const [symbol, setSymbol] = useState("");
  function trySetSymbol(e) {
    setSymbol(e);
  }
  const [submitText, setSubmitText] = useState("Add/Update Locate");
  async function tryGetData(e) {
    if (e) {
      const s = locates.find((doc) => {
        return doc.id === e;
      });
      if (s) {
        setTotalAmount(s.total);
        setNewAmount(s.total + 1);
        setRate(s.rate);
        setSubmitText("Update Locate");
      } else {
        setTotalAmount(undefined);
        setNewAmount(undefined);
        setRate(undefined);
        setSubmitText("Add Locate");
      }
    } else {
      setTotalAmount(undefined);
      setNewAmount(undefined);
      setRate(undefined);
      setSubmitText("Add Locate");
    }
  }
  //try to set the rate
  const [rate, setRate] = useState();
  function trySetRate(e) {
    if (e > 0 && !isNaN(e)) {
      setRate(Number(e));
    } else {
      setRate(undefined);
    }
  }

  const deleteFile = (fileRef) => {
    deleteObject(fileRef)
      .then(() => {
        setActionMessage(`File ${fileRef.name} deleted successfully`);
      })
      .catch((error) => {
        enqueueSnackbar("Error deleting file: " + error, {variant: "error"});
      });
  };

  async function handleETBUpload(e) {
    setLoading(true);
    const file = e.target.files[0];

    //remove all previous etb files
    const storage = getStorage();
    const listRef = ref(storage, 'etb/'); // Reference to your 'etb' bucket

    listAll(listRef)
      .then((res) => {
        res.items.forEach((itemRef) => {
          // Delete each file
          deleteFile(itemRef);
        });
      })
      .catch((error) => {
        enqueueSnackbar("Error listing files: " + error, {variant: "error"});
      });

    //upload the new file
    const storageRef = ref(storage, 'etb/' + file.name);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      setActionMessage('Upload is ' + progress + '% done');
    }, (error) => {
      enqueueSnackbar("Error uploading file: " + error, {variant: "error"});
      setLoading(false);
    }, () => {
      // Handle successful uploads on complete
      enqueueSnackbar("File uploaded successfully", {variant: "success"});
      setLoading(false);
    });

  };

  function handleCsvUpload(e) {
    setLoading(true);
    const file = e.target.files[0];
    Papa.parse(file, {
      //header: true,
      dynamicTyping: true,
      complete: function (result) {
        uploadToFirestore(result.data, e.target.id);
      },
    });
  };


  async function uploadToFirestore(data, id) {
    //if we start the day, we need to remove all locates and requests
    if (id === "day-start") {
      setActionMessage("Removing previous day locates ...");
      const removedLocates = await removeLastDayRecords("locates");
      enqueueSnackbar(`Removed previous day locates: ${removedLocates}`, {variant: "success"});
      setActionMessage("Removing previous day requests ...");
      const removedRequests = await removeLastDayRecords("requests");
      enqueueSnackbar(`Removed previous day requests: ${removedRequests}`, {variant: "success"});

      //delete all previous day allocation files
      const storage = getStorage();
      const listRef = ref(storage, 'requested/'); // Reference to your 'etb' bucket

      listAll(listRef)
        .then((res) => {
          res.items.forEach((itemRef) => {
            // Delete each file
            deleteFile(itemRef);
          });
        })
        .catch((error) => {
          enqueueSnackbar("Error listing files: " + error, {variant: "error"});
        });
    }

    const tStamp = serverTimestamp();
    let batch = [];
    let updatedLocates = 0;

    for (let i = 1; i < data.length; i++) {
      if (data[i][0] != null && data[i][1] != null) { //check there is a symbol and amount
        if (id === "day-start") { //if we start the day, upload all locates
          const symbol = data[i][0].replace(/p/g, '$').replace(/\//g, '_');
          const amount = data[i][1];
          const rate = data[i][2] ? data[i][2] : 0; // as rate is not required, set it to 0 if not provided
          // add a setDoc operation to the batch
          batch.push({'symbol': symbol, 'total': amount, 'available': amount, 'rate': rate, 'created': tStamp, 'updated': null, 'user': appUser?.id});
          updatedLocates++;
          if (batch.length === batchSize) { // if batch is full, commit it
            await commitBatch(batch, "set");
            batch = []; // cerate a new batch
          }
        } else { // if we update intraday, update locates
          const symbol = data[i][0].replace(/p/g, '$').replace(/\//g, '_');
          const amount = data[i][1];
          const rate = data[i][2] ? data[i][2] : 0; // as rate is not required, set it to 0 if not provided
          const foundDoc = locates.find((doc) => {
            return doc.id === symbol; // find the locate in the locates collection
          });
          updatedLocates++;
          if (foundDoc) { // if found, update the available amount
            const na = amount - foundDoc.total + foundDoc.available;
            const newAvail = na > 0 ? na : 0; // available cannot be negative, but total can cause it while updating with a new amount
            batch.push({'symbol': symbol, 'total': amount, 'available': newAvail, 'rate': rate, 'updated': tStamp, 'user': appUser?.id});
          } else { // if not found, add a new locate
            batch.push({'symbol': symbol, 'total': amount, 'available': amount, 'rate': rate, 'created': tStamp, 'user': appUser?.id});
          }
          if (batch.length === batchSize) { // if batch is full, commit it
            await commitBatch(batch, "set");
            batch = []; // cerate a new batch
          }
        }
        setActionMessage(`Uploaded records: ${updatedLocates}`);
      } else {
        console.log(`Skipping row ${i} as it has no symbol or amount`);
      }
    }
    // commit the last batch, as it may not be full
    if (batch.length > 0) {
      await commitBatch(batch, "set");
      setActionMessage(`Uploaded records: ${updatedLocates}`);
    }
    enqueueSnackbar(`Uploaded records: ${updatedLocates}`, {variant: "success"});
    setLoading(false);
  };

  async function commitBatch(data, op) {
    const db = getFirestore();
    const batch = writeBatch(db);
    data.forEach((d) => {
      switch (op) {
        case "set":
          batch.set(doc(db, "locates", d.symbol), d, {merge: true});
          break;
        case "delete":
          batch.delete(d);
          break;
        default:
          console.log("Unknown operation");
      }
    });
    try {
      await batch.commit();
    } catch (e) {
      console.log(e);
      enqueueSnackbar(`Error ${op === "set" ? "updating" : "removing"} records:\n ${e}`, {variant: "error"});
    }
  }

  async function removeLastDayRecords(collectionName) {
    const db = getFirestore();
    const collectionRef = collection(db, collectionName === "locates" ? "locates" : "requests");
    const records = await getDocs(collectionRef);
    let batch = [];
    records.forEach(async (d) => {
      batch.push(d.ref);
      if (batch.length === batchSize) {
        await commitBatch(batch, "delete");
        batch = [];
      }
    });
    if (batch.length > 0) {
      await commitBatch(batch, "delete");
      batch = [];
    }
    return records.docs.length;
  }

  async function postRequest(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const foundDoc = locates.find((doc) => {
        return doc.id === symbol;
      });
      const db = getFirestore();
      const docRef = doc(db, "locates", symbol);
      if (foundDoc) {
        if (newAmount > totalAmount || rate !== foundDoc.rate) {
          await updateDoc(docRef, {
            total: newAmount > totalAmount ? newAmount : totalAmount,
            rate: rate,
            available: newAmount > totalAmount ? newAmount - totalAmount + foundDoc.available : foundDoc.available,
            user: appUser?.id,
            updated: serverTimestamp(),
          });
          enqueueSnackbar(`Updated ${foundDoc.id}.`, {variant: "success"});
        } else {
          enqueueSnackbar(`Found ${foundDoc.id}, ${foundDoc.total}, ${foundDoc.rate} no update needed`, {variant: "warning"});
        }
      } else {
        setSubmitText("Add Locate");
        try {
          await setDoc(docRef, {
            total: newAmount,
            available: newAmount,
            rate: rate,
            user: appUser?.id,
            created: serverTimestamp(),
            updated: '',
          });
          enqueueSnackbar(`Added new locate: ${symbol}, amount:${newAmount}, rate:${rate}`, {variant: "success"});
        } catch (e) {
          enqueueSnackbar(`Error adding document: ${e}`, {variant: "error"});
        }
      }
    } catch (e) {
      enqueueSnackbar(`Error adding document: ${e}`, {variant: "error"});
    } finally {
      setLoading(false);
      setSymbol();
      setNewAmount();
      setRate();
      setTotalAmount();
    }
  }

  const hiddenFileInput = useRef(null);
  function handleClick(event) {
    hiddenFileInput.current.click();
  };

  const hiddenFileUpdate = useRef(null);
  function handleUpdateClick(event) {
    hiddenFileUpdate.current.click();
  };

  const hiddenETBUpdate = useRef(null);
  function handleETBClick(event) {
    hiddenETBUpdate.current.click();
  };

  return (
    <div className="full-div">
      {loading ?
        <div className="loading-container">
          <CircularProgress />
          <Typography variant="body1">{actionMessage}</Typography>
        </div>
        :
        <div className="allocate-container">
          <div className="alllocate-partial-container">
            <Button className="login-button left-locates" onClick={handleClick} disabled={loading}>Start the day (HTB)</Button>
            <input
              id="day-start"
              type="file"
              accept=".csv"
              onChange={handleCsvUpload}
              ref={hiddenFileInput}
              style={{display: 'none'}}
            />
            <Button className="login-button left-locates" onClick={handleUpdateClick} disabled={loading}>Intraday update (HTB)</Button>
            <input
              id="day-update"
              type="file"
              onChange={handleCsvUpload}
              ref={hiddenFileUpdate}
              style={{display: 'none'}} />
            <Button className="login-button left-locates" onClick={handleETBClick} disabled={loading}>Update ETB</Button>
            <input
              id="etb-update"
              type="file"
              onChange={handleETBUpload}
              ref={hiddenETBUpdate}
              style={{display: 'none'}} />
          </div>
          <div className="alllocate-partial-container">
            <form className='allocate-form'>
              <h5>Single symbol update</h5>
              <input
                className='login-text-input'
                name='symbol-text'
                type='text'
                placeholder='Enter Symbol'
                onChange={(e) => trySetSymbol(e.target.value)}
                value={symbol}
                onBlur={(e) => tryGetData(e.target.value)}
              />
              <div className='amount-for-allocation'>
                Amount to set:{newAmount} &gt; {totalAmount}
              </div>
              <input
                className='login-text-input'
                name='amount-text'
                type='number'
                placeholder='Enter New Amount'
                onChange={(e) => trySetNewAmount(e.target.value)}
                value={newAmount}
              />
              <input
                className='login-text-input'
                name='rate-text'
                type='number'
                placeholder='Enter Rate'
                onChange={(e) => trySetRate(e.target.value)}
                value={rate}
              />
              <Button
                className="login-button left-locates"
                type='submit'
                disabled={newAmount <= totalAmount || !rate || !symbol || loading}
                onClick={postRequest}>
                {loading ? "Requesting..." : submitText}
              </Button>
            </form>
          </div>
        </div>
      }
    </div>
  );
};

export default AddLocate;
